var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$vuetify.breakpoint.mobile ? _c('v-card', {
    staticClass: "white--text",
    attrs: {
      "width": "260",
      "tile": "",
      "flat": "",
      "elevation": "0",
      "color": "#366fd7"
    }
  }, [_c('v-card-title', {
    staticClass: "py-30px"
  }, [_c('span', {
    staticClass: "tit tit--sm"
  }, [_vm._v("상품권 교환소")])]), _c('v-list', [_c('v-list-item-group', {
    attrs: {
      "mandatory": ""
    },
    model: {
      value: _vm.category._id,
      callback: function callback($$v) {
        _vm.$set(_vm.category, "_id", $$v);
      },
      expression: "category._id"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": "",
      "value": null
    }
  }, [_c('v-list-item-title', [_vm._v("상품권 전체")])], 1), _c('v-divider'), _vm._l(_vm.categories, function (category, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "value": category._id,
        "dense": ""
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(category.name))])], 1);
  })], 2)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }